import gql from 'graphql-tag'

const GET_CITIES = gql`
  query cities($tenantId: Int!, $name: String, $offset: Int, $limit: Int) {
    cities(tenantId: $tenantId, name: $name, offset: $offset, limit: $limit) {
      total
      data {
        id
        name
      }
    }
  }
`

export { GET_CITIES }
